import { useContext } from "react";
import { AppContext } from "../context/app";
import { hasAtLeastRole } from "../utils/roles";
import { StaffRole } from "../types/roles";

export const usePermissions = () => {
  const app = useContext(AppContext);

  if (!app) {
    throw new Error(
      "usePermissions must be used within an AppContext.Provider",
    );
  }

  const user = app?.user;

  return {
    hasAtLeastRole: (requiredRole: StaffRole) =>
      hasAtLeastRole({ user, requiredRole }),
  };
};
